import { memo } from 'react'
import injectSheet from 'react-jss'
import ProductHero from '@/components/ProductHero'
import CarouselProductMobile from '@/components/CarouselProductMobile'
import style from './style'

const ProductCoverMobile = ({
  classes,
  cover,
  overview,
  title,
  subtitle,
  visible,
}) => {
  return (
    <div className={classes.root}>
      <div className={classes.imageWrapper}>
        {cover && (
          <img
            src={cover}
            alt={title}
          />
        )}
        <ProductHero
          className={classes.title}
          title={title}
          subtitle={subtitle}
          visible={visible}
        />
      </div>
      <div className={classes.carouselWrapper}>
        <CarouselProductMobile
          items={overview}
        />
      </div>
    </div>
  )
}

export default injectSheet(style)(memo(ProductCoverMobile))
